import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { keys } from '@/api/queryKeys';
import { useAppConfigContext } from '@/context/AppConfig';
import { AppRequests } from '@/context/AppRequests';

export const useLastArticles = () => {
  const { getLatestArticles } = useContext(AppRequests).ArticlesRequests;
  const { logError } = useAppConfigContext();

  const result = useQuery({
    queryKey: [keys.LATEST_ARTICLES],
    queryFn: getLatestArticles,
    onError: (error) => {
      logError('Error fetching articles', error as Error);
    },
  });

  return { ...result };
};

export const useVideoArticles = () => {
  const { getVideoArticles } = useContext(AppRequests).ArticlesRequests;
  const { logError } = useAppConfigContext();

  const result = useQuery({
    queryKey: [keys.VIDEO_ARTICLES],
    queryFn: getVideoArticles,
    onError: (error) => {
      logError('Error fetching video articles', error as Error);
    },
  });

  return { ...result };
};

export const useArticles = () => {
  const { getArticles } = useContext(AppRequests).ArticlesRequests;
  const { logError } = useAppConfigContext();

  const result = useQuery({
    queryKey: [keys.ARTICLES],
    queryFn: getArticles,
    onError: (error) => {
      logError('Error fetching articles', error as Error);
    },
  });

  return { ...result };
};
